<template>
    <div class="grid-container" :style="cssVars">
        <component :is="item.link.startsWith('/') ? 'router-link' : 'a'"
                   class="grid-card button"
                   v-for="(item, index) in data"
                   :key="index"
                   :href="item.link"
                   :to="item.link">
            <div class="image-container">
                <image-view v-if="item.image"
                            size="medium"
                            class="img raster"
                            :url="item.image"/>
                <img v-else-if="item.icon"
                     class="svg"
                     :src="require(`@/assets/${item.icon}-24px.svg`)"
                     :alt="item.name"/>
            </div>
            <div class="card-name">
                <div>{{item.name}}</div>
            </div>
        </component>
    </div>
</template>

<script>
	import ImageView from "@/components/ImageView";

	export default {
		name: "GridView",
		components: {ImageView},
		props: {
			data: {
				type: Array,
				required: true
			},
			size: {
				type: String,
				required: true
			},
			constantSize: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				cssVars: {
					"--col-size": this.size,
					"--fit-type": this.constantSize ? "auto-fill" : "auto-fit"
				}
			};
		}
	}
</script>

<style scoped lang="scss">
    .grid-container {
        display: grid;
        grid-template-columns: repeat(var(--fit-type),
                minmax(var(--col-size), 1fr));
        grid-gap: 24px;
    }

    .grid-card {
        display: block;
        position: relative;
        padding: calc(var(--col-size) / 5) calc(var(--col-size) / 10) calc(var(--col-size) / 8) calc(var(--col-size) / 10);
    }

    .image-container {
        position: relative;
        margin: 0 auto;
        width: 90%;
        height: 0;
        padding-bottom: 90%;
        border-radius: 50%;
        z-index: 1;
        overflow: hidden;
        @extend %solid-box;
    }

    .img.raster {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    img.svg {
        position: absolute;
        top: 25%;
        left: 25%;
        width: 50%;
        height: 50%;
    }

    .card-name {
        display: flex;
        position: relative;
        padding: 8px 0;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-top: 8px;
        min-height: 2em;
        white-space: pre-wrap;
        max-width: 100%;
        overflow: hidden;
    }

    .card-name > div {
        width: 100%;
        word-wrap: break-word;
    }

    @include gridFallback {
        .grid-card {
            display: inline-block;
            width: var(--col-size);
            margin: 0 24px 24px 0;
        }
    }
</style>